import { inject, Injectable } from '@angular/core';
import { PrimeNG } from 'primeng/config';

@Injectable({
	providedIn: 'root',
})
export class PrimeNGTranslationService {
	private readonly primeNgConfig = inject(PrimeNG);
	private translations = {
		en: {
			accept: 'Yes',
			reject: 'No',
			choose: 'Choose',
			upload: 'Upload',
			cancel: 'Cancel',
			dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
			monthNames: [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			],
			monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			today: 'Today',
		},
		sr: {
			accept: 'Da',
			reject: 'Ne',
			choose: 'Izaberi',
			upload: 'Učitaj',
			cancel: 'Otkaži',
			dayNames: ['Nedelja', 'Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota'],
			dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
			dayNamesMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
			monthNames: [
				'Januar',
				'Februar',
				'Mart',
				'April',
				'Maj',
				'Jun',
				'Jul',
				'Avgust',
				'Septembar',
				'Oktobar',
				'Novembar',
				'Decembar',
			],
			monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
			today: 'Danas',
		},
	};

	private getTranslations(language: 'en' | 'sr' = 'en') {
		return this.translations[language];
	}

	setTranslation(language: 'en' | 'sr' = 'en') {
		this.primeNgConfig.setTranslation(this.getTranslations(language));
	}
}
